import { useParams } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { getNewSockeInstance } from "../../../socket";
import "./Output.css";
import "../quotes/FlippingQuoteCard.css";
import FixedSuperScreen from "../../../components/UI/FixedSuperScreen/FixedSuperScreen";
import { isVideoPlaying } from "../../../utils/utility";
import FlipCardInner from "../quotes/FlipCardInner";
import SocialOutputSettings from "../../../screens/Social/Settings";
import { DEFAULT_SETTINGS_CONTROLLABLE_OUTPUT_QUOTES } from "../../../utils/defaultSettings";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { uvenuFetcher } from "../../../utils/uvenu-fetcher";
import { URLS } from "../../../constants";

const Output = () => {
  const socket = useRef(getNewSockeInstance()).current;
  const { eventId } = useParams();
  const [isFlipped, setIsFlipped] = useState(null);

  const [frontCardMedia, setFrontCardMedia] = useState(null);

  const [backCardMedia, setBackCardMedia] = useState(null);

  const [QuoteCardSettingDialogOpen, setQuoteCardSettingDialogOpen] =
    useState(false);
  const [quoteCardSettings, setQuoteCardSettings] = useState(
    DEFAULT_SETTINGS_CONTROLLABLE_OUTPUT_QUOTES
  );

  const [isSocketConnected, setIsSocketConnected] = useState(
    socket?.connected || null
  );

  const isTurned = useRef(false);
  const flipTimeout = useRef(null);
  const flip = () => {
    if (flipTimeout.current) {
      clearTimeout(flipTimeout.current);
    }
    flipTimeout.current = setTimeout(() => {
      setIsFlipped(!isFlipped);
    }, 100);
  };
  const quoteCardStyle = {
    id: 1,
    color: quoteCardSettings.backgroundColor,
    bgImage: quoteCardSettings.backgroundImage || null,
    contentColor: "#fff",
  };
  const getMediaItem = (media, isFront) => {
    return media ? (
      media?.mimeType?.includes("video") ? (
        <video
          src={media.content}
          style={{ height: "100%" }}
          muted
          id={`video-${media.id}`}
          onLoad={flip}
          onLoadedMetadata={flip}
          preload="auto"
        ></video>
      ) : media?.mimeType?.includes("image") ? (
        <img
          src={media.content}
          style={{ height: "100%" }}
          alt="Front of cfc-card"
          onLoad={flip}
        />
      ) : media?.comment ? (
        <div
          className="soImageMedia quoteOnlyCard"
          style={{
            width: "100%",
            aspectRatio: "16/9",
            fontFamily: `${quoteCardSettings.font}`,
          }}
        >
          <FlipCardInner
            isControllableOutput={true}
            key={media.id}
            isFront={isFront}
            data={media}
            styles={quoteCardStyle}
            cardWidth={window.innerWidth * 0.9}
            {...quoteCardSettings}
          />
        </div>
      ) : null
    ) : (
      <div className="skeleton" style={{ height: "100%" }} />
    );
  };

  const currentBackCardMediaRef = useRef(null);
  const currentFrontCardMediaRef = useRef(null);

  useEffect(() => {
    isTurned.current = isFlipped;
  }, [isFlipped]);
  useEffect(() => {
    currentFrontCardMediaRef.current = frontCardMedia;
    return () => {
      currentFrontCardMediaRef.current = null;
    };
  }, [frontCardMedia]);
  useEffect(() => {
    currentBackCardMediaRef.current = backCardMedia;
    return () => {
      currentBackCardMediaRef.current = null;
    };
  }, [backCardMedia]);

  const activeItemReceivedRef = useRef(null);
  const handleNewQuoteMessage = (data) => {
    clearTimeout(activeItemReceivedRef.current);
    activeItemReceivedRef.current = setTimeout(() => {
      if (isTurned.current) {
        if (currentBackCardMediaRef.current?.id === data.id) {
          setIsFlipped(false);
        } else {
          setFrontCardMedia(data);
          setIsFlipped(false);
        }
      } else {
        if (currentFrontCardMediaRef.current?.id === data.id) {
          setIsFlipped(true);
        } else {
          setBackCardMedia(data);
          setIsFlipped(true);
        }
      }
    }, 100);
  };

  const handleNewMediaMessage = (data) => {
    clearTimeout(activeItemReceivedRef.current);
    activeItemReceivedRef.current = setTimeout(() => {
      if (isTurned.current) {
        if (currentFrontCardMediaRef.current?.id === data.activeItem.id) {
          setIsFlipped(false);
        } else {
          setFrontCardMedia(data.activeItem);
        }
      } else {
        if (currentBackCardMediaRef.current?.id === data.activeItem.id) {
          setIsFlipped(true);
        } else {
          setBackCardMedia(data.activeItem);
        }
      }
    }, 100);
  };
  const handleVideoPlayPause = (data) => {
    const video = document.querySelector(`#video-${data.id}`);
    let playPromise;

    document.querySelectorAll("video").forEach((element) => {
      if (isVideoPlaying(element)) {
        if (playPromise !== undefined) {
          playPromise
            .then((_) => {
              element.pause();
              element.currentTime = 0;
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          element.pause();
          element.currentTime = 0;
        }
      }
    });
    if (video) {
      if (data.play) {
        playPromise = video.play();
      } else {
        if (playPromise !== undefined) {
          playPromise
            .then((_) => {
              video.pause();
              video.currentTime = 0;
            })
            .catch((error) => {
              console.log(error);
            });
        }
      }
    }
  };
  const handleMute = (data) => {
    const video = document.querySelector(`#video-${data.id}`);
    if (video) {
      video.muted = data.mute;
    }
  };
  const handleLoop = (data) => {
    const video = document.querySelector(`#video-${data.id}`);
    if (video) {
      video.loop = data.loop;
    }
  };

  const getLastMessage = async () => {
    const response = await uvenuFetcher({
      url: URLS.GET_LAST_MESSAGE(eventId),
      method: "GET",
    });
    if (response && response.statusCode === 200 && response.json.message) {
      return response.json.message;
    }
    return null;
  };

  useEffect(() => {
    const getLastSocketMessage = async () => {
      const message = await getLastMessage();
      if (message && message?.message) {
        const messageObject = JSON.parse(message.message);
        if (
          messageObject &&
          messageObject.activeItem &&
          messageObject.activeItem.mimeType
        ) {
          handleNewMediaMessage(messageObject);
        } else if (messageObject.activeItem.comment) {
          handleNewQuoteMessage(messageObject.activeItem);
        }
      }
    };
    socket.on("connect", () => {
      socket.emit("joinRoom", eventId + "-contorllable-output");
      setIsSocketConnected(true);
      getLastSocketMessage();
    });

    socket.on("dataArray", (data) => {
      // Load Newly Arrived Item
      if (data && data.activeItem) {
        if (data.activeItem.mimeType) {
          handleNewMediaMessage(data);
        } else if (data.activeItem.comment) {
          handleNewQuoteMessage(data.activeItem);
        }
      }

      // Play/Pause Video
      if (data && data.play !== undefined && data.id) {
        handleVideoPlayPause(data);
      }
      // Mute/Unmute Video
      if (data && data.mute !== undefined && data.id) {
        handleMute(data);
      }
      // Loop Video
      if (data && data.loop !== undefined && data.id) {
        handleLoop(data);
      }

      // Reload
      if (data && data.type === "reload") {
        window.location.reload();
      }
    });
    socket.connect();

    socket.on("disconnect", () => {
      setIsSocketConnected(false);
    });

    window.addEventListener("beforeunload", () => {
      socket.disconnect();
    });

    return () => {
      socket.off("dataArray");
      socket.disconnect();
      clearTimeout(activeItemReceivedRef.current);
    };
  }, []);

  const onQuoteSettingsClick = () => {
    setQuoteCardSettingDialogOpen(true);
  };
  const renderQuoteCardSettings = () => {
    return (
      <>
        <Dialog
          open={QuoteCardSettingDialogOpen || false}
          onClose={() => setQuoteCardSettingDialogOpen(false)}
          fullWidth
        >
          <DialogTitle>Settings</DialogTitle>
          <DialogContent className="dialog-content">
            <SocialOutputSettings
              onChange={setQuoteCardSettings}
              localStorageUniqueKey={"controllableOutputQuoteSettings"}
              defaultSettings={quoteCardSettings}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setQuoteCardSettingDialogOpen(false)}>
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  };

  return (
    <>
      <FixedSuperScreen
        eventId={eventId}
        onQuoteSettingsClick={onQuoteSettingsClick}
        isSocketConnected={isSocketConnected}
        quoteCardSettings={quoteCardSettings}
        setQuoteCardSettings={setQuoteCardSettings}
      >
        <div
          id="cfc-flip-card-main"
          className={`cfc-card-container ${isFlipped ? "flipped" : ""}`}
        >
          <div className="cfc-card">
            <div className="cfc-card-front">
              {getMediaItem(frontCardMedia, true)}
            </div>
            <div className="cfc-card-back">
              {getMediaItem(backCardMedia, false)}
            </div>
          </div>
        </div>
      </FixedSuperScreen>
      {renderQuoteCardSettings()}
    </>
  );
};
export default Output;
